import { ProgressBar } from "./progress-bar.js";
import { ProgressBarStyles, ProgressBarTemplate } from "@fluentui/web-components";
import { DesignSystem } from "../design-system.js";
/**
 * The Fabric Progress Bar component.
 *
 * @public
 */
export const definition = ProgressBar.compose({
    name: `${DesignSystem.prefix}-progress-bar`,
    template: ProgressBarTemplate,
    styles: ProgressBarStyles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=progress-bar.definition.js.map